import Visibility from "@mui/icons-material/Visibility";
import Task from "@mui/icons-material/Task";
import { IconButton, Tooltip, Box } from "@mui/material";
import { MaterialReactTable, useMaterialReactTable } from "material-react-table";
import { MRT_Localization_ES } from "material-react-table/locales/es";
import { useMemo } from "react";
import { tableConfig, tableStyles } from "../../commons/table/tableConfig";
import { formatDate } from "../../../util/datetime";


const Presentaciones415Table = ({ data = [], loading = false, handleVer = () => { }, handleFinalizar = () => { } }) => {

  const columns = useMemo(
    () => [
      {
        header: "Nro. Presentación",
        id: "nroPresentacion",
        align: "center",
        accessorKey: "nroPresentacion",
      },
      {
        header: "Nro. Muestra",
        id: "nroMuestra",
        align: "center",
        accessorKey: "nroMuestra",
      },
      {
        header: "Vigencia Desde",
        id: "fechaInicioVigencia",
        align: "center",
        accessorKey: "fechaInicioVigencia",
        Cell: ({ cell }) => formatDate(cell.getValue()),
      },
      {
        header: "Vigencia Hasta",
        id: "fechaFinVigencia",
        align: "center",
        accessorKey: "fechaFinVigencia",
        Cell: ({ cell }) => formatDate(cell.getValue()),
      },
      {
        header: "Fecha Vencimiento",
        id: "fechaVencimientoEmpleador",
        align: "center",
        accessorKey: "fechaVencimientoEmpleador",
        Cell: ({ cell }) => formatDate(cell.getValue()),
      },
      {
        header: "Estab. Declarados",
        accessorFn: (row) =>
          row.estabDeclarados ??
          row.establecimientosDeclarados ??
          row.cantidadEstablecimientosDeclarados ??
          row.cantEstablecimientos ??
          "",
        id: "estabDeclarados",
        align: "center",
      },
      {
        header: "Estado",
        accessorFn: (row) => row.estado ?? row.descripcionEstado ?? row.nombreEstado ?? "",
        id: "estado",
        align: "center",
      },
    ],
    []
  );

  const table = useMaterialReactTable({
    ...tableConfig,
    columns,
    data: data,
    layoutMode: "grid",
    state: { isLoading: loading },
    localization: MRT_Localization_ES,
    initialState: { showColumnFilters: false },
    style: {
      ...tableStyles.container,
      marginTop: "0",
    },
    enableRowActions: true,
    renderRowActions: ({ row }) => (
      <Box sx={{ display: 'flex', gap: '0.2rem', justifyContent: 'center' }}>
        {(row.original.estado ?? row.original.descripcionEstado ?? row.original.nombreEstado) === "Iniciada" && (
          <Tooltip title="Finalizar Presentacion">
            <IconButton
              size="medium"
              onClick={() => handleFinalizar(row.original)}
              sx={{ color: '#007A5E' }}
            >
              <Task />
            </IconButton>
          </Tooltip>
        )}
        <Tooltip title="Ver Presentación">
          <IconButton
            size="medium"
            onClick={() => handleVer(row.original)}
            sx={{ color: '#007A5E' }}
          >
            <Visibility />
          </IconButton>
        </Tooltip>
      </Box>
    ),
    positionActionsColumn: "last",
    enableGlobalFilter: false,
    enableColumnFilters: false,
    enableDensityToggle: false,
    enableFullScreenToggle: false,
    enableColumnActions: false,
    enableColumnOrdering: false,
    enableHiding: false,
    muiTableHeadCellProps: {
      sx: {
        ...tableConfig?.muiTableHeadCellProps?.sx,
        justifyContent: "center",
      },
    },
    muiTableBodyCellProps: {
      sx: { justifyContent: "center" },
    },
    displayColumnDefOptions: {
      "mrt-row-actions": {
        muiTableHeadCellProps: {
          align: "center",
        },
        header: "",
        size: 50,
      },
    },
  });

  return <MaterialReactTable table={table} />;
};

export default Presentaciones415Table;
